module.exports = __webpack_public_path__ + "img/szktz-url-banner.843e719e.png";